import {
  DronePackageDelivery,
  LoyaltyBonusCard,
  TarabutLoader,
  GLFLDronePackageDelivery,
  GLFLLoyaltyBonusCard,
  GLFLRequestReminder,
  GLFLSoftwareDevelopment,
  FluencyOk,
} from "../assets/gif";
import {
  Nafath_Verify,
  New_Bank,
  Eligible_For_Finance,
  Riyadh_Bank,
  Maximum_Trial,
  Request_Error,
  Bank_Revenue,
  ApplicationSubmitSuccess,
  SaudiAwwalBankFavicon,
  SabBank,
  HourglassRepresenting,
  BGFleetFinanceMin,
  FleetFinanceCampaignCarsMin,
  FleetFinanceDistributorBgMin,
  TechnyClipboardWithChecklist,
} from "../assets/images";
import {
  PhoneCall,
  Globe,
  Email,
  SaudiFlag,
  NafathLogo,
  Briefcase,
  WathqLogo,
  LinkIcon,
  Support,
  LeftIcon,
  AmexLanding,
  SaudiCentral,
  LockIcon,
  ErrorIcon,
  RightIcon,
  CrossIcon,
  Shield,
  Clock,
  AmexLoader,
  SNBLoader,
  DaemLoader,
  GeideaLoader,
  UploadDocument,
  GreenTickCircle,
  CircleQuestionMark,
  AlRajhiBankFavicon,
  AlinmaBankFavicon,
  ArabNationalBankFavicon,
  BankAlbiladFavicon,
  BankAljaziraFavicon,
  BanqueSaudiFransiFavicon,
  MeemByGulfInternationalBankFavicon,
  RiyadBankFavicon,
  TheSaudiInvestmentBankFavicon,
  GreenBankFavicon,
  BlueBankFavicon,
  SNBLogo,
  AlinmaBankLogo,
  BankAlbiladLogo,
  RedExclamationCircle,
  AlbiladBank,
  AlinmaBank,
  AljaziraBank,
  AlrajhiBank,
  AnbBank,
  BanqueSaudiBank,
  GulfInternationalBank,
  RiyadBank,
  SaudiInvestmentBank,
  FileType,
  MoneyBagDisbursement,
  UploadCloudBlack,
  WhiteLock,
  QuestionMark,
  FileIconOrange,
  CheckBorderOutlinedCircle,
  DownloadCloudOrange,
  SandClockIcon,
  WalletIcon,
  FileTypeIcon,
  SignatureIcon,
  InfoOutlinedCircle,
  CheckVerifiedOrange,
  UploadCloudOrange,
  ShieldDollarOrange,
  ArrowRight,
  PackageBoxOrange,
  PackageBoxSecondary,
  PackageBoxPlusSecondary,
  PhoneIncomingWhite,
  CircleSaudiFlag,
  WarningExclamationCircle,
  EditOrangeIcon,
  ArrowRightOrangeIcon,
  AnnotationInfoSuccess,
  ArrowLeftOrange,
} from "../assets/svgs";

export const getSvgLoader = (name) => {
  switch (name) {
    case "amex":
      return AmexLoader;
    case "snb":
      return SNBLoader;
    case "daem":
      return DaemLoader;
    case "tarabut":
      return TarabutLoader;
    case "GEIDEA":
      return GeideaLoader;
    default:
      return TarabutLoader;
  }
};

export const getSvgComponent = (name) => {
  switch (name) {
    case "phone":
      return PhoneCall;
    case "website":
      return Globe;
    case "email":
      return Email;
    case "nafath_logo":
      return NafathLogo;
    case "briefcase":
      return Briefcase;
    case "wathq_logo":
      return WathqLogo;
    case "link_icon":
      return LinkIcon;
    case "support":
      return Support;
    case "left_blue":
      return LeftIcon;
    case "amex_landing":
      return AmexLanding;
    case "saudi_central":
      return SaudiCentral;
    case "lock":
      return LockIcon;
    case "error":
      return ErrorIcon;
    case "right_icon":
      return RightIcon;
    case "cross_icon":
      return CrossIcon;
    case "shield":
      return Shield;
    case "clock":
      return Clock;
    case "albilad_bank":
      return BankAlbiladLogo;
    case "alinma_bank":
      return AlinmaBankLogo;
    case "snb":
      return SNBLogo;
    case "upload_document":
      return UploadDocument;
    case "green_tick":
      return GreenTickCircle;
    case "how_it_work":
      return CircleQuestionMark;
    case "red_exclamation":
      return RedExclamationCircle;
    case "file_type":
      return FileType;
    case "money_bag":
      return MoneyBagDisbursement;
    case "upload_document_black":
      return UploadCloudBlack;
    case "white-lock":
      return WhiteLock;
    case "question-mark":
      return QuestionMark;
    case "file-icon-orange":
      return FileIconOrange;
    case "check-border-outlined-circle":
      return CheckBorderOutlinedCircle;
    case "download_cloud_orange":
      return DownloadCloudOrange;
    case "sand_clock_icon":
      return SandClockIcon;
    case "wallet_icon":
      return WalletIcon;
    case "file_type_icon":
      return FileTypeIcon;
    case "signature_icon":
      return SignatureIcon;
    case "info_outlined_circle":
      return InfoOutlinedCircle;
    case "check_verified_orange":
      return CheckVerifiedOrange;
    case "upload_cloud_orange":
      return UploadCloudOrange;
    case "shield_dollar_orange":
      return ShieldDollarOrange;
    case "arrow_right":
      return ArrowRight;
    case "package_box_orange":
      return PackageBoxOrange;
    case "package_box_secondary":
      return PackageBoxSecondary;
    case "package_box_plus_secondary":
      return PackageBoxPlusSecondary;
    case "phone_incoming_white":
      return PhoneIncomingWhite;
    case "edit_orange_icon":
      return EditOrangeIcon;
    case "arrow_right_orange_icon":
      return ArrowRightOrangeIcon;
    case "annotation_info_success":
      return AnnotationInfoSuccess;
    case "arrow_left_orange":
      return ArrowLeftOrange;
    default:
      return null;
  }
};

export const getPngImages = (name) => {
  switch (name) {
    case "nafath_verify":
      return Nafath_Verify;
    case "new_bank":
      return New_Bank;
    case "eligible_for_finance":
      return Eligible_For_Finance;
    case "riyadh_bank":
      return Riyadh_Bank;
    case "maximum_trial":
      return Maximum_Trial;
    case "request_success":
      return Eligible_For_Finance;
    case "incorrect_info":
      return Request_Error;
    case "calculate_bank_revenue":
      return Bank_Revenue;
    case "application_submitted":
      return Eligible_For_Finance;
    case "app_rejection":
      return Request_Error;
    case "join_queue_congrats":
      return Eligible_For_Finance;
    case "amex_landing":
      return AmexLanding;
    case "saudi_central":
      return SaudiCentral;
    case "lock":
      return LockIcon;
    case "right_icon":
      return RightIcon;
    case "error":
      return ErrorIcon;
    case "application_submit_success":
      return ApplicationSubmitSuccess;
    case "drone_package_delivery":
      return DronePackageDelivery;
    case "loyalty_bonus_card":
      return LoyaltyBonusCard;
    case "glfl_drone_package_delivery":
      return GLFLDronePackageDelivery;
    case "glfl_loyalty_bonus_card":
      return GLFLLoyaltyBonusCard;
    case "glfl_request_reminder":
      return GLFLRequestReminder;
    case "glfl_hourglass_representing":
      return HourglassRepresenting;
    case "glfl_software_development":
      return GLFLSoftwareDevelopment;
    case "bg-fleet-finance":
      return BGFleetFinanceMin;
    case "fleet_finance_campaign_cars":
      return FleetFinanceCampaignCarsMin;
    case "fluency_ok":
      return FluencyOk;
    case "fleet_finance_distributor_bg_min":
      return FleetFinanceDistributorBgMin;
    case "warning_exclamation_circle":
      return WarningExclamationCircle;
    case "techny_clipboard_with_checklist":
      return TechnyClipboardWithChecklist;
    default:
      return null;
  }
};

export const getCountryFlag = (isoCode) => {
  switch (isoCode) {
    case "SAU":
      return SaudiFlag;
    case "SA":
      return CircleSaudiFlag;
    default:
      return null;
  }
};

export const getBankFaviconAsSvg = (providerId) => {
  switch (providerId) {
    case "SNB": // "SNB"
      return "/assets/banks/snb_favicon.png";
    case "INMA": // Alinma Bank
      return AlinmaBankFavicon;
    case "BASA-SAU": // Banque Saudi fransi
      return BanqueSaudiFransiFavicon;
    case "SAIB-SAU": // The Saudi Investment Bank
      return TheSaudiInvestmentBankFavicon;
    case "ALRA-SAU": // Al Rajhi Bank
      return AlRajhiBankFavicon;
    case "BAAL-SAU": // Bank Albilad
      return BankAlbiladFavicon;
    case "MEEM-SAU": // Meem by Gulf International Bank
      return MeemByGulfInternationalBankFavicon;
    case "ANBB": // Arab National Bank
      return ArabNationalBankFavicon;
    case "RIBL": // Riyad Bank
      return RiyadBankFavicon;
    case "SABR-SAU": // Saudi Awwal Bank
      return SaudiAwwalBankFavicon;
    case "BAJA-SAU": // Bank Aljazira
      return BankAljaziraFavicon;
    case "GREN": // Demo Green Bank
      return GreenBankFavicon;
    case "BLUE": // Demo Blue Bank
      return BlueBankFavicon;
    default:
      return null;
  }
};

export const getBankLogos = (providerId) => {
  switch (providerId) {
    case "SNB": // "SNB"
      return "assets/banks/snb.png";
    case "INMA": // Alinma Bank
      return AlinmaBank;
    case "BASA-SAU": // Banque Saudi fransi
      return BanqueSaudiBank;
    case "SAIB-SAU": // The Saudi Investment Bank
      return SaudiInvestmentBank;
    case "ALRA-SAU": // Al Rajhi Bank
      return AlrajhiBank;
    case "BAAL-SAU": // Bank Albilad
      return AlbiladBank;
    case "MEEM-SAU": // Meem by Gulf International Bank
      return GulfInternationalBank;
    case "ANBB": // Arab National Bank
      return AnbBank;
    case "RIBL": // Riyad Bank
      return RiyadBank;
    case "SABR-SAU": // Saudi Awwal Bank
      return SabBank;
    case "BAJA-SAU": // Bank Aljazira
      return AljaziraBank;
    case "GREN": // Demo Green Bank
      return GreenBankFavicon;
    case "BLUE": // Demo Blue Bank
      return BlueBankFavicon;
    default:
      return null;
  }
};
